<template>
    <div class="commentItemWrap">
        <div class="commentItemInfo">
            <div class="commentItemAvatar">
                <img :src="cont.avatar">
            </div>
            <div class="commentItemMain">
                <div class="commentItemName curp" @click="jumpOut">{{cont.nickname}}</div>
                <div class="commentItemDate">{{cont.ctime | formatDate}}</div>
            </div>
        </div>
        <div class="commentItemCont">
            {{commentContent}}
        </div>
        <div class="commentItemReplys">
            <slot></slot>
        </div>
        <div class="commentItemOpe">
            <div class="commentItemNice" :class="{
          'commentItemNiceActive': !!like.flag
        }" @click="setCommentLike" v-if="!isNew">赞{{like.likes}}</div>
            <div class="commentItemReply" :class="{
          'commentItemReplyActive': reply
        }" v-if="!isNew" @click="handleReply">回复</div>
        </div>
        <div class="commentItemReplyWrap" v-if="reply">
            <textarea class="commentItemReplySendInput" ref="replyInput" :placeholder="' 回复' + cont.nickname" v-model="replyContent"></textarea>
            <div class="commentItemReplySendBtn" @click="handleSendReply">发送</div>
        </div>
    </div>
</template>

<script>
import * as common from '../utils/common'
import * as actions from '../actions'
// import md5 from 'js-md5'
export default {
    name: 'CommentItem',
    props: {
        'cont': {
            type: Object
        },
        'like': {
            type: Object,
            default: function () {
                return {
                    likes: 0,
                    flag: 0
                }
            }
        },
        'likeKey': {
            type: String
        },
        'setLike': {
            type: Function
        },
        'isNew': {
            type: Boolean,
            default: function () {
                return false
            }
        },
        'pid': {
            type: [Number, String]
        },
        'id': {
            type: [Number, String]
        },
        'insertNewReply': {
            type: Function
        }
    },
    data() {
        return {
            reply: false,
            replyContent: ''
        }
    },
    filters: {
        formatDate: function (ts) {
            return common.timeAgo(parseInt(ts) * 1000)
        }
    },
    computed: {
        isLogin: function () {
            return common.isLogin()
        },
        commentContent(str) {
            let newStr = this.$utils.thscSnsBaselibUtils.utf16toEntitie(this.cont.content);
            newStr = this.$utils.thscSnsBaselibUtils.uncodeUtf16(newStr);
            return this.$utils.thscSnsBaselibUtils.formatImgToEmoji(newStr);
        }
    },
    methods: {
        jumpOut() {
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.names.click`)
            window.open(`//t.10jqka.com.cn/${this.cont.userid}/`)
        },
        /**
         * 评论点赞
         */
        setCommentLike: async function () {
            if (!this.isLogin) {
                this.$client.showBrowserDlgTip({ text: '您还未登录，请先登录' })
                return
            }
            try {

                // let data = await actions.setCommentLike.call(this, this.likeKey)
                // if (data.errorcode === 0) {
                //   console.log('点赞点赞点赞点赞点赞点赞')
                //   this.setLike(this.likeKey)
                // }

                // 评论区点赞的接口改动
                // console.log('this.likeKey', this.likeKey);
                // let tokenValue = md5(this.likeKey+'ths10jqka');
                // console.log('token:', tokenValue)
                // this.$commonApi.ZanInPromise({
                //   key:this.likeKey,
                //   filed: 'likes',
                //   app:'news',
                //   token: tokenValue
                // }).then(res=>{
                //   console.log('commonApi评论区点赞', res)
                //   if(res.errorcode === 0) {
                //     this.setLike(this.likeKey)
                //   }
                // })

                this.$sendStat(`pc_newschrome_${window.statSeq}.comments.praise.click`);

                // 0.0.9
                // let tokenValue = md5(this.likeKey+'ths10jqka');
                // console.log('this.likeKey', this.likeKey);
                // console.log('token:', tokenValue);
                commonApi.addLikes({
                    key: this.likeKey,
                    field: 'likes',
                    app: 'sns',
                    // token: '79542563821f49e041b4cc0439834438'
                }).then(res => {
                    console.log('commonApi评论区点赞', res)
                    if (res.errorcode === 0) {
                        this.setLike(this.likeKey)
                    }
                })

            } catch (e) {
                console.warn('setCommentLike ', e)
            }
        },

        /**
     * 点击回复
     */
        handleReply: function () {
            // this.$sendPoint('plhf')

            if (!this.isLogin) {
                this.$client.showBrowserDlgTip({ text: '您还未登录，请先登录' })
                return
            }
            // this.$sendStat('pcnewsbrowser_pinglunhuifu')
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.reply.click`);

            this.reply = !this.reply
            this.$nextTick(() => {
                if (this.reply) {
                    this.$refs.replyInput.focus()
                }
            })
        },

        /**
     * 发送回复
     */
        handleSendReply: async function () {
            if (!this.replyContent) return
            let cont = this.replyContent
            // eslint-disable-next-line
            let userid = getUserid()
            // eslint-disable-next-line
            let username = getAccount()
            let avatar = `//u.thsi.cn/avatar/${userid.slice(-4)}/${userid}.gif`
            let date = new Date()
            let utime = `${common.fillZero(date.getMonth() + 1)}-${common.fillZero(date.getDate())} ${common.fillZero(date.getHours())}:${common.fillZero(date.getMinutes())}`
            let commentObj = {
                cont: cont,
                userid: userid,
                uname: username,
                avatar: avatar,
                utime: utime,
                to: userid,
                pid: this.pid,
                rid: this.id
            }
            this.replyContent = ''
            this.reply = false

            // this.$sendStat('pcnewsbrowser_pinglunfasong')
            this.$sendStat(`pc_newschrome_${window.statSeq}.comments.reply.click`);

            try {
                let data = await actions.sendReply.call(this, commentObj)
                if (data.errorCode === 0) {
                    this.$client.showBrowserDlgTip({ text: '回复成功' })
                    // this.$sendPoint('plhfcg')
                    this.$sendStat(`pc_newschrome_${window.statSeq}.comments.replytoast`);

                    this.insertNewReply({
                        content: cont,
                        nickname: username,
                        avatar: avatar,
                        rid: this.id,
                        ctime: Date.parse(new Date()) / 1000
                    })
                } else {
                    this.$client.showBrowserDlgTip({ text: data.errorMsg })
                }
            } catch (e) {
                console.warn(e)
            }
        }
    }
}
</script>

<style lang="less">
@import './index.less';
</style>
